import { api } from "./api";

export const dashboardApi = (data) => {
  return api.get(
    `/api/admin/dashboard?date_range=${data?.date_range}`,
    JSON.stringify(data)
  );
};
